import { Component, OnInit } from '@angular/core';

import { SeoService } from '../service/seo.service';
import { GlobalComponent } from '../global/global.component';
import { Router } from '@angular/router';

@Component({
  selector: 'login-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.scss']
})
export class AboutusComponent implements OnInit {
  
 hostName = GlobalComponent.hostName;


  constructor(private SEOService:SeoService,private router:Router) { 
    window.scroll(0, 0);
  }

  ngOnInit(){  

  this.SEOService.updateCanonicalUrl(this.hostName + '/aboutus');

  }
  signup()
  {
    this.router.navigate(['/login/signup']);

  }


}
